<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="8" lg="6">
        <b-card>
          <b-form @submit.prevent="save()">
            <b-row>
              <b-col sm="12" lg="6">
                <b-form-group label-for="name">
                  <template #label>
                    Version
                    <span class="text-danger">&nbsp;*</span>
                  </template>
                  <b-form-input id="version" v-model="form.version" placeholder="1.x.x" required />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label-for="username_field">
                  <template #label>
                    Notes
                    <span class="text-danger">&nbsp;*</span>
                  </template>
                  <b-form-textarea id="username_field" v-model="form.notes" />
                </b-form-group>
              </b-col>
              <b-col class="d-flex justify-content-end">
                <b-button type="button" @click.prevent="$router.push({name: 'app-version-index'})" class="mr-1" variant="light">
                  Cancel
                </b-button>
                <b-button type="submit" :disabled="isLoading" variant="primary">
                  Save
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BRow,
  BCol,
  BContainer,
  BFormGroup,
  BCard,
  BFormInput,
  BButton,
  BForm,
  BFormCheckbox,
  BInputGroup,
  BInputGroupAppend,
  BFormTextarea,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'

import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BContainer,
    BFormGroup,
    BCard,
    BFormInput,
    BButton,
    BForm,
    BFormCheckbox,
    BInputGroup,
    BInputGroupAppend,
    BFormTextarea,
    vSelect,
  },

  mixins: [togglePasswordVisibility],

  data() {
    return {
      isLoading: false,
      availableRole: [
        'approver',
        'admin',
        'telkom a',
        'telkom b',
      ],
      optionsSync: [
        {label: 'Yes', value: true}, 
        {label: 'No', value: false}
      ],
      form: {
        version: '',
        notes: '',
      },
    }
  },

  computed: {
    paramID() {
      return this.$route.params.key
    },
    isEdit(){
      return !!this.paramID
    },
  },
  mounted() {
    if (this.isEdit) {
      this.getVersion()
    }
  },
  methods: {
    addVersion() {
      this.isLoading = true
      this.$http
        .post('/app-version',  {...this.form })
        .then(() => {
          this.$notif('Success', 'Version has been successfully added.', 'success')
          this.$router.push({ name: 'app-version-index' })
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
    updateVersion() {
      this.isLoading = true
      this.$http
        .put(`/app-version/${this.paramID}`, this.form)
        .then(() => {
          this.$notif('Success', 'Version has been successfully updated.', 'success')
          this.$router.push({ name: 'app-version-index' })
        })
        .catch(({ data }) => this.$notif('Error', `${data.message}`, 'error'))
        .finally(() => {
          this.isLoading = false
        })
    },
    async getVersion() {
      return await this.$http.get(`/app-version/id/${this.paramID}/set/first`)
      .then(res => {
        let data = res.data.data.records
        this.form.version = data.version
        this.form.notes = data.notes
      })
    },
    save() {
      if (this.isEdit) {
        this.updateVersion()
      } else {
        this.addVersion()
      }
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>